/* eslint-disable react/prop-types */
import React from "react";
import "../../assets/styles/App.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import { createOrgSiteAndUser, getAllOrgTags } from "../../constants/endpoints";
import { getAuthenticatedData, postAuthenticatedData } from "../../utils/async";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { withTranslation } from "react-i18next";
import { T_GENERAL, T_SERVICE } from "../../constants/translations";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/**
 * This is the component for the Add Organization modal in the Service Page. <br>
 * There are two screens in this modal, controlled by state variables. <br>
 * The first one is collect organization info, while the second is to collect user info.
 *
 * @component
 */
class CustomAddOrgModal extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;

    this.state = {
      organizationname: "",
      sitedomain: "",
      sitename: "",
      city: "",
      state: "",
      sosNumber: "",
      sosCustomerName: "",
      sosCustomerContact: "",
      sosCustomerEmail: "",
      dateOfInstallation: null,
      firstname: "",
      lastname: "",
      email: "",
      employeeid: "",
      isLoaded: true,
      disableFirstButton: true,
      disableSecondButton: true,
      activePage: 1,
      isADEnabled: false,
      sitetenant: "",
      organizationTagsList: [],
      organizationTags: []
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFirstPageProceed = this.onFirstPageProceed.bind(this);
    this.goToFirstPage = this.goToFirstPage.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
  }

  componentDidMount() {
    getAuthenticatedData(sessionStorage.getItem("domain") + getAllOrgTags).then(
      res => {
        this.setState({ organizationTagsList: res.data });
      }
    );
  }

  /**
   * Handles changes to any field in the form
   *
   *
   * @param {object} e      event listener
   */
  onChange(e) {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        this.validateForm();
      }
    );
  }

  /**
   * Handles organization tag multi-select changes
   *
   * @param {string} tagValue - The tag value being toggled
   */
  onTagChange(tagValue) {
    const { organizationTags } = this.state;
    let updatedTags;

    if (organizationTags.includes(tagValue)) {
      // Remove tag if already selected
      updatedTags = organizationTags.filter(tag => tag !== tagValue);
    } else {
      // Add tag if not selected
      updatedTags = [...organizationTags, tagValue];
    }

    this.setState(
      {
        organizationTags: updatedTags
      },
      () => {
        this.validateForm();
      }
    );
  }
  onDateChange(date) {
    this.setState(
      {
        dateOfInstallation: date
      },
      () => {
        this.validateForm();
      }
    );
  }

  /**
   * Validates form and updates button states
   */
  validateForm() {
    const {
      organizationname,
      sitedomain,
      sitename,
      city,
      state,
      sosNumber,
      sosCustomerName,
      sosCustomerContact,
      sosCustomerEmail,
      dateOfInstallation,
      isADEnabled,
      sitetenant,
      firstname,
      lastname,
      email,
      employeeid
    } = this.state;

    this.setState({
      disableFirstButton:
        organizationname === "" ||
        sitedomain === "" ||
        sitename === "" ||
        city === "" ||
        state === "" ||
        sosNumber === "" ||
        sosCustomerName === "" ||
        sosCustomerContact === "" ||
        sosCustomerEmail === "" ||
        dateOfInstallation === null ||
        (isADEnabled && sitetenant === ""),
      disableSecondButton:
        firstname === "" || lastname === "" || email === "" || employeeid === ""
    });
  }

  /**
   * Proceeds to the second page
   *
   *
   */
  onFirstPageProceed() {
    this.setState({ activePage: 2 });
  }

  /**
   * Submits the form and makes an API call
   *
   *
   */
  onSubmit() {
    var data = {
      orgInfo: {
        orgName: this.state.organizationname,
        isADOrg: this.state.isADEnabled,
        organisationTags: this.state.organizationTags
      },
      siteInfo: {
        domain: this.state.sitedomain,
        name: this.state.sitename,
        isParentSite: true,
        city: this.state.city,
        state: this.state.state,
        sosNumber: this.state.sosNumber,
        sosCustomerName: this.state.sosCustomerName,
        sosCustomerContact: this.state.sosCustomerContact,
        sosCustomerEmail: this.state.sosCustomerEmail,
        dateOfInstallation: this.state.dateOfInstallation.getTime(),
        ...(this.state.isADEnabled && { adTenantId: this.state.sitetenant })
      },
      userInfo: {
        employeeId: this.state.employeeid,
        email: this.state.email + "@" + this.state.sitedomain,
        firstName: this.state.firstname,
        lastName: this.state.lastname
      }
    };
    this.setState({ isLoaded: false, disableSecondButton: true });

    postAuthenticatedData(
      sessionStorage.getItem("domain") + createOrgSiteAndUser,
      data
    )
      .then(result => {
        this.setState({ isLoaded: true });
        if (result.status === 200) {
          toast.success(this.t(T_SERVICE.toast.addOrgSuccessful));
          this.setState({
            organizationname: "",
            sitedomain: "",
            sitename: "",
            city: "",
            state: "",
            sosNumber: "",
            sosCustomerName: "",
            sosCustomerContact: "",
            sosCustomerEmail: "",
            dateOfInstallation: null,
            firstname: "",
            lastname: "",
            email: "",
            employeeid: "",
            activePage: 1,
            sitetenant: "",
            isADEnabled: false
          });
          this.props.closePopup();
          this.props.resetList();
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message);
        }
      });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  /**
   * Goes to the first page
   *
   *
   */
  goToFirstPage() {
    this.setState({ activePage: 1 });
  }

  render() {
    return (
      <div className="custommodal">
        <div className="custommodalinner">
          {(() => {
            if (this.state.activePage === 2) {
              return (
                <a className="add-org-back" onClick={this.goToFirstPage}>
                  &lt; {this.t(T_GENERAL.back)}
                </a>
              );
            }
          })()}
          <form
            className="loginpad custom-add-exam-patient-modal"
            onSubmit={this.handleSubmit}
          >
            <h6 className="modal-heading">
              {this.t(T_SERVICE.addOrganization.header)}
            </h6>
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={this.props.closePopup}
              className="cancle"
            >
              {" "}
              x{" "}
            </Button>
            <hr className="hrpadding" />
            {(() => {
              if (this.state.activePage === 1) {
                return (
                  <div className="firstpage">
                    <FormGroup controlId="name" bsSize="medium">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.name)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            autoFocus
                            required
                            type="text"
                            name="organizationname"
                            value={this.state.organizationname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row formfont">
                        <div className="col-md-3 formfont enable-label">
                          {this.t(T_SERVICE.addOrganization.adEnabled)}
                        </div>
                        <div className="col-md-9">
                          <BootstrapSwitchButton
                            width={100}
                            height={10}
                            checked={this.state.isADEnabled}
                            onstyle="success"
                            onChange={checked =>
                              this.setState(
                                {
                                  isADEnabled: checked,
                                  sitetenant: ""
                                },
                                () => {
                                  this.validateForm();
                                }
                              )
                            }
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="organizationTags" bsSize="medium">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.organizationTag)}
                        </div>
                        <div className="col-md-9">
                          <div
                            className="multi-select-container"
                            style={{
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "8px",
                              maxHeight: "120px",
                              overflowY: "auto"
                            }}
                          >
                            {this.state.organizationTagsList.length > 0 ? (
                              this.state.organizationTagsList.map(orgTag => (
                                <div
                                  key={orgTag}
                                  className="checkbox-item"
                                  style={{ marginBottom: "5px" }}
                                >
                                  <label
                                    style={{
                                      fontWeight: "normal",
                                      marginBottom: "0",
                                      cursor: "pointer"
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      value={orgTag}
                                      checked={this.state.organizationTags.includes(
                                        orgTag
                                      )}
                                      onChange={() => this.onTagChange(orgTag)}
                                      style={{ marginRight: "8px" }}
                                    />
                                    {orgTag}
                                  </label>
                                </div>
                              ))
                            ) : (
                              <div
                                style={{ color: "#666", fontStyle: "italic" }}
                              >
                                No tags available
                              </div>
                            )}
                          </div>
                          {this.state.organizationTags.length > 0 && (
                            <div
                              style={{
                                marginTop: "5px",
                                fontSize: "12px",
                                color: "#666"
                              }}
                            >
                              Selected: {this.state.organizationTags.join(", ")}
                            </div>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                    <hr className="org-line" />
                    <h6 className="org-subheading">
                      {this.t(T_SERVICE.addOrganization.primarySite)}
                    </h6>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.siteDomain)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="sitedomain"
                            value={this.state.sitedomain}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.siteName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="sitename"
                            value={this.state.sitename}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="city" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">City</div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="city"
                            value={this.state.city}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="state" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">State</div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="state"
                            value={this.state.state}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="sosNumber" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">SOS Number</div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="sosNumber"
                            value={this.state.sosNumber}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="sosCustomerName" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          SOS Customer Name
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="sosCustomerName"
                            value={this.state.sosCustomerName}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="sosCustomerContact" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          SOS Customer Contact
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="sosCustomerContact"
                            value={this.state.sosCustomerContact}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="sosCustomerEmail" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          SOS Customer Email
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="email"
                            name="sosCustomerEmail"
                            value={this.state.sosCustomerEmail}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="dateOfInstallation" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          Date of Installation
                        </div>
                        <div className="col-md-9">
                          <DatePicker
                            selected={this.state.dateOfInstallation}
                            onChange={this.onDateChange}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select date"
                            required
                          />
                        </div>
                      </div>
                    </FormGroup>

                    {(() => {
                      if (this.state.isADEnabled) {
                        return (
                          <FormGroup controlId="email" bsSize="large">
                            <div className="row">
                              <div className="col-md-3 formfont">
                                {this.t(T_SERVICE.addOrganization.siteTenantID)}
                              </div>
                              <div className="col-md-9">
                                <FormControl
                                  required
                                  type="text"
                                  name="sitetenant"
                                  value={this.state.sitetenant}
                                  onChange={this.onChange}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        );
                      }
                    })()}

                    <Button
                      onClick={this.onFirstPageProceed}
                      className="loginbtn1 create-account-btn create-org-btn"
                      disabled={this.state.disableFirstButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_SERVICE.addOrganization.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </div>
                );
              } else {
                return (
                  <div className="firstpage">
                    <h6 className="org-subheading">
                      {this.t(T_SERVICE.addOrganization.primaryUser)}
                    </h6>
                    <FormGroup controlId="name" bsSize="medium">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.firstName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            autoFocus
                            required
                            type="text"
                            name="firstname"
                            value={this.state.firstname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.lastName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="lastname"
                            value={this.state.lastname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row input-email">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.email)}
                        </div>
                        <div className="col-md-4">
                          <FormControl
                            required
                            type="text"
                            name="email"
                            value={this.state.email}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-5 domain-name">
                          {this.state.sitedomain === "" ? "" : "@"}
                          {this.state.sitedomain}
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_SERVICE.addOrganization.employeeId)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="employeeid"
                            value={this.state.employeeid}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit}
                      className="loginbtn1 create-account-btn create-org-btn"
                      disabled={this.state.disableSecondButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_GENERAL.submit)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </div>
                );
              }
            })()}
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomAddOrgModal);
